import type { GraphMailPayload } from "@/types/feed";

/** Resolve the stored Graph mailbox id from a feed payload (new or legacy rows). */
export function graphMailMailboxId(payload: GraphMailPayload): string | null {
  if (payload.mailbox_id) return payload.mailbox_id;
  return payload.attachments?.[0]?.mailbox_id ?? null;
}

/** Stored `clients.graph_messages.id` row referenced by the feed payload. */
export function graphMailMessageId(payload: GraphMailPayload): string | null {
  return payload.graph_message_id ?? null;
}

/** True when the payload carries enough ids to lazy-load the message body. */
export function canLoadGraphMailBody(payload: GraphMailPayload): boolean {
  return !!graphMailMailboxId(payload) && !!graphMailMessageId(payload);
}
